'use client';

import { useEffect, useState } from 'react';
import { X } from 'lucide-react';

interface BannerMessageProps {
  id: string;
  content: string;
}

const STORAGE_KEY = 'bareun.banner-message.dismissed';

export function BannerMessage({ id, content }: BannerMessageProps) {
  // SSR/hydration mismatch 방지: 마운트 후에만 표시 여부 결정
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const dismissed = window.localStorage.getItem(STORAGE_KEY);
      if (dismissed !== id) {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, [id]);

  const handleDismiss = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, id);
    } catch {
      // localStorage 가 비활성화된 환경에서도 즉시 닫히도록 무시
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="relative border-b border-[#104573]/25 bg-[#a8c2d8] dark:bg-[#0b2742] dark:border-white/10">
      <div className="flex items-center justify-center px-12 py-2 max-w-7xl mx-auto">
        <div
          className="min-w-0 truncate text-center text-sm text-[#104573] dark:text-[#cfe2f3] [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:text-[#0b3559] dark:[&_a:hover]:text-white text-center"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
      <button
        type="button"
        aria-label="배너 닫기"
        onClick={handleDismiss}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded-md p-1 text-[#104573]/70 hover:text-[#104573] hover:bg-[#104573]/10 dark:text-white/70 dark:hover:text-white dark:hover:bg-white/10 transition"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
